import { render, staticRenderFns } from "./LabelSelectorAntV.vue?vue&type=template&id=5bfc6729&scoped=true&"
import script from "./LabelSelectorAntV.vue?vue&type=script&lang=js&"
export * from "./LabelSelectorAntV.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelectorAntV.vue?vue&type=style&index=0&id=5bfc6729&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfc6729",
  null
  
)

export default component.exports